import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { XCircle } from 'lucide-react';
export function WhyFailSection() {
  const failures = ['Sé constante', 'Contestá rápido', 'Poné más emojis', 'Hacé más stories'];
  return <Section background="cream" className="text-center" data-id="element-133">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} data-id="element-134">
        <h2 className="font-serif text-3xl md:text-4xl text-[#2D2D2D] mb-12" data-id="element-135">
          Los consejos genéricos no funcionan
        </h2>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-4xl mx-auto mb-12" data-id="element-136">
          {failures.map((item, index) => <div key={index} className="relative group" data-id="element-137">
              <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100 flex flex-col items-center justify-center h-32" data-id="element-138">
                <span className="text-lg text-gray-400 font-medium line-through decoration-red-400 decoration-2" data-id="element-139">
                  {item}
                </span>
                <XCircle className="text-red-400 mt-2 w-6 h-6 opacity-50" data-id="element-140" />
              </div>
            </div>)}
        </div>

        <p className="text-lg md:text-xl text-[#2D2D2D] max-w-3xl mx-auto leading-relaxed" data-id="element-141">
          Nada de eso resuelve el punto exacto donde se cae tu venta:{' '}
          <br className="hidden md:block" data-id="element-142" />
          <span className="font-bold bg-[#C5A55A]/20 px-2" data-id="element-143">
            no tenés un guión claro
          </span>{' '}
          para llevar la conversación y cerrar.
        </p>
      </motion.div>
    </Section>;
}